import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GroupPageOptions } from "../Constants/RegistrationPageOptions";
import EventCardList from "./EventCardList";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import DateHelpers from "../Helper/DateHelpers";
import InputValidation from "../Helper/InputValidation";
import DataAccessHelper from "../Helper/DataAccessHelper";
import '../Styles/DayCampRegistrationPayment.scss';

function ReservationPayment({ account, 
   paymentAmount, setPaymentAmount, amountDue, setAmountDue, paymentType, setPaymentType, numberOfSpots, week, selectedPage, setSelectedPage, validateAndProcessReservation }) {

   const [paymentIntent, setPaymentIntent] = useState({})
   const [unprocessedPaymentIntentId, setUnprocessedPaymentIntentId] = useState()
   const [customerId, setCustomerId] = useState("")
   const [clientSecret, setClientSecret] = useState("")
   const [isProcessingPayment, setIsProcessingPayment] = useState(false)
   const options = { clientSecret }

   // What the Stripe dashboard's description is built from, e.g. "Youth Camp Week 2, 2026 (Reservation)".
   const stripeDescriptionDetails = {
      event: { camp_type: week?.camp_type, camp_name: week?.camp_name, week_num: week?.week_num, begin_date: week?.begin_date },
      paymentOption: 'reservation',
   }

   const stripePromise = loadStripe("pk_live_51Qj8NvRstlwNU15E4RDarYStMSEcfHxbadUFqI9kSoC2Ux263Q9MNwMSVwFVhPLMxYWzD6R5MZDH2Eet5lG6afAY00VDLdBkCa")

   // Promo Code Items - Uncomment if you need later!
   // const [enteredPromo, setEnteredPromo] = useState('');
   // const promoCode = 'BRR20';
   // const promoAmount = 20; // dollars
   // const [hasPromo, setHasPromo] = useState(false);
   // const [promoApplied, setPromoApplied] = useState(false); // to avoid double-discount

   const fetchCustomer = async () => {
      let stripeCustomerId = await registerForEvent()
      console.log("Stripe customer id to be passed to the payment intent", stripeCustomerId)

      // Check to see if the customer id state has already been set
      if (stripeCustomerId != customerId) {
         setCustomerId(stripeCustomerId)
         console.log("Setting the customer id state for the first time.")
      }
      else {
         console.log("Customer id state already set. Update the payment intent price")
         updatePaymentIntent()
      }
   };

   async function registerForEvent() {
      let userEmail = account.group_email
      console.log(userEmail, "Here is the user email")
      var response = await fetch('api/createcustomer', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         // Group accounts have no first/last name, so the admin's name stands in, then the group's.
         body: JSON.stringify({ email: userEmail, name: account.church_group_admin || account.group_name }),
      });

      const data = await response.json();
      console.log('Stripe Customer ID:', data.stripeCustomerId);
      return data.stripeCustomerId; // Retrieve customer_id
   }


   const createPaymentIntent = async (customer_id, price) => {
      console.log(customer_id, "CUSTOMER_ID to be passed down to payment intent!")
      var response = await fetch('api/create-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ customerId: customer_id, price: price, ...stripeDescriptionDetails })
      })

      const data = await response.json();
      console.log("data returned from payment intent", data)
      console.log('The Created Payment Intent: ', data.paymentIntentInfo)
      var clientSecretAndId = data.paymentIntentInfo;
      setUnprocessedPaymentIntentId(clientSecretAndId.id)
      return { clientSecret: clientSecretAndId.clientSecret, id: clientSecretAndId.id };
   }

   const updatePaymentIntent = async () => {
      console.log("Unprocessed Payment Intent Id to be updated", unprocessedPaymentIntentId)
      console.log("Updated payment amount", paymentAmount)
      let totalDue = (paymentAmount * 100)
      var response = await fetch('api/update-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ paymentIntentId: unprocessedPaymentIntentId, price: totalDue, ...stripeDescriptionDetails })
      })
   }

const HandlePayment = async () => {
  try {
    // 1. Confirm with Stripe first
    const confirmed = await validateAndProcessReservation(paymentIntent.id);
    if (!confirmed) {
      console.error("Stripe did not confirm payment");
      // Hand the page back to the user so they can correct the card and retry.
      setIsProcessingPayment(false);
      return;
    }

    // 2. Now safe to proceed with registration logic
    if (paymentIntent.status === "succeeded") {
      const pricePaid = InputValidation.shiftDecimalLeft(paymentIntent.amount, 2);
      const eventPrice = paymentAmount;
      const amountDue = (eventPrice - pricePaid).toFixed(2);
      console.log("event price", eventPrice);

      setAmountDue(amountDue);
      setPaymentType("Credit"); // or however you classify it
    }
  } catch {
    console.error("Stripe did not confirm payment");
    setIsProcessingPayment(false);
  }
};

   // const applyPromoCode = () => {
   //    if (enteredPromo.trim().toUpperCase() === promoCode && !promoApplied) {
   //       setHasPromo(true);
   //       setPromoApplied(true); // Set this first before changing payment amount
         
   //       // Calculate the new amount
   //       const newPaymentAmount = Math.max(paymentAmount - promoAmount, 0);
   //       setPaymentAmount(newPaymentAmount);
   //    }
   // }

   // Display price options and credit card dropdown
   useEffect(() => {
      if (!paymentAmount) {
         return
      }
   
      fetchCustomer();
   }, [])

   useEffect(() => {
      const fetchPaymentIntent = async () => {
         if (!customerId) return;

         let totalDue = (paymentAmount * 100)
         console.log("totalDue", totalDue)
         let secret = await createPaymentIntent(customerId, totalDue);
         console.log("Received Client Secret:", secret.clientSecret)

         setClientSecret(secret.clientSecret)

      }
      fetchPaymentIntent();
   }, [customerId])

   // Get the response from Stripe, and calculate remaining amount due.
   // paymentIntent starts as an empty object, so the id is what tells us Stripe has actually
   // responded — checking the object alone fires this on mount with an undefined id.
   useEffect(() => {
      if (!paymentIntent?.id) {
         return
      }
      console.log("payment Intent!!", paymentIntent)
      console.log("status", paymentIntent.status)
      HandlePayment()
   }, [paymentIntent])

   useEffect(() => {
      if (!amountDue) {
         return
      }
      console.log("payment Intent!!", paymentIntent)
      console.log("status", paymentIntent.status)
      console.log("amount due", amountDue)
      setPaymentType('Credit')
   }, [amountDue])

      function PrevPage(event) {
         event.preventDefault()
         setSelectedPage(GroupPageOptions.Review)
      }

   return (
      <div className="DayCampRegistrationPaymentContent">
         <div className="DayCampRegistrationPaymentHeading">
            Payment
         </div>

         <div className="DayCampRegistrationPaymentPaymentInformation">
            <div className="DayCampRegistrationPaymentPaymentInformationAmount">
               Payment Amount: ${Number(paymentAmount).toFixed(2)}
            </div>
            {clientSecret && (
               <Elements stripe={stripePromise} options={options}>
                  <CheckoutForm
                     setPaymentIntent={setPaymentIntent}
                     onProcessingChange={setIsProcessingPayment} />
               </Elements>
            )}
         </div>
         {/* Hidden while Stripe is confirming so the only thing on screen is the spinner and the
             do-not-refresh notice, matching the individual and day camp payment pages. */}
         {!isProcessingPayment &&
            <div className="DayCampRegistrationPaymentButtonsContainer">
               <div className="DayCampRegistrationPaymentButtons">
                  <div className="DayCampRegistrationPaymentPreviousButton">
                     <button onClick={PrevPage}>
                        Previous
                     </button>
                  </div>
               </div>
            </div>
         }
      </div>
   )
}

export default ReservationPayment
